export const CORRECTORA = '#05b3ce';
export const GAS = '#fba400';
export const AGUA = '#75da4e';
export const PRESION = '#802392';
//
export const ACTIVO = '#2de946';
export const INACTIVO = '#e22f2f';
//
export const VERDE = '#00da3d';
export const AMARILLO = '#fded22';
export const ROJO = '#f7000b';
//
/**
 * Lee una CSS variable del tema en `:root`. Fallback: el valor de la marca
 * horatech, por si se consulta antes de que cargue la hoja de estilos.
 */
export function varCss(nombre: string, porDefecto: string): string {
  if (typeof document === 'undefined') return porDefecto;
  return (
    getComputedStyle(document.documentElement)
      .getPropertyValue(nombre)
      .trim() || porDefecto
  );
}
// Colores de marca: salen del tema (assets/estilos/light-colores.scss y la
// marca activa), no de una constante. Se leen al cargar el módulo.
export const ACCENT = varCss('--accent-color', '#06accc');
export const WARN = varCss('--warn-color', '#f7000b');

/**
 * Paleta de series de un gráfico: `--serie-1` … `--serie-N` del tema si la
 * marca las define; si no, la paleta propia del gráfico. Se lee al armar el
 * gráfico, no al cargar el módulo, para que la hoja de la marca ya esté.
 */
export function paletaSeries(porDefecto: string[]): string[] {
  return porDefecto.map((color, i) => varCss(`--serie-${i + 1}`, color));
}
